import {format, formatDistanceToNow, isToday} from "date-fns";

class DateFns {
    constructor(date) {
        this.date = new Date(date);
    }

    format(dateFormat = 'MM/dd/Y') {
        return format(this.date, dateFormat);
    }

    distanceToNow() {
        return formatDistanceToNow(this.date, {addSuffix: true, includeSeconds: false});
    }

    isToday() {
        return isToday(this.date);
    }

    combinationDateAndTime() {
        return this.isToday() ? this.format('h:mm a') : this.format('MMMM d, y h:mm a');
    }

    formatWithDistance(format, dateFormat) {
        return format.replace(':distance', this.distanceToNow()).replace(':date', this.format(dateFormat));
    }

    formattedDateString() {
        return this.format('MMMM d, y');
    }
}

export function date(date) {
    return new DateFns(date);
}
